import React, { useEffect, useMemo, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useHistory } from "react-router-dom";
import Logo from "../../images/managekaro logo.png";
import expiredItems from "../../images/expiredItems.png";
import expiredItemsG from "../../images/expiredItemsG.png";
import notificationsgreen from "../../images/bell-green.png";
import counterpart from "counterpart";
import eng from "../../lang/eng";
import urdu from "../../lang/urdu";
import notificationBell from "../../images/notification-bell.png";
import busGreen from "../../images/busGreen.svg";
import busGrey from "../../images/busGrey.svg";
import CashGreen from "../../images/cash green.svg";
import PaymentGreen from "../../images/payments green.svg";
import PaymentGrey from "../../images/payments grey.svg";
import CashGrey from "../../images/cash grey.svg";
import PropertyGreen from "../../images/property green.svg";
import PropertyGrey from "../../images/property grey.svg";

import { Button, Dialog, DialogContent, Typography } from "@mui/material";
import { Box, Stack, IconButton, Toolbar, styled } from "@mui/material";
import { Badge, List, ListItem, Drawer, Divider, AppBar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import StoreIcon from "@mui/icons-material/Store";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { endTrial, getTrial } from "../trial/trialSlice";
import { findExpireDays } from "../../utils/findExpireDays";
import useGetTab from "./useGetTab";
import { useLocation } from "react-router-dom";
import { clearInventory, saleQuantity } from "../../components/inventory/itemsSlice";
import {trailRemoved} from "../trial/trialSlice";
import CashInHandNew from "../../images/cashinhand-new.svg";
import ledgersgreennew from "../../images/ledgersgreen-new.svg";
import dailybookgreennew from "../../images/dailybookgreen-new.svg";
import dashboardgreennew from "../../images/dashboardgreen-new.svg";
import salegreennew from "../../images/salegreen-new.svg";
import itemsgreennew from "../../images/itemsgreen-new.svg";
import billsgreennew from "../../images/billsgreen-new.svg";
import purchasegreennew from "../../images/purchasegreen-new.svg";
import salereturngreennew from "../../images/salereturn-new.svg";
import reportsgreennew from "../../images/reportsgreen-new.svg";
import companygreennew from "../../images/companygreen-new.svg";
import BarcodeGreen from "../../images/barcode-green.svg";
import BarcodeGrey from "../../images/barcode-grey.svg";
import BillGreen from "../../images/bill-green.svg";
import BillGrey from "../../images/bill-grey.svg";
import CompanyProfileGreen from "../../images/companyProfile-green.svg";
import CompanyProfileGrey from "../../images/companyProfile-grey.svg";
import DailyBookGreen from "../../images/dailyBook-green.svg";
import DailyBookGrey from "../../images/dailyBook-grey.svg";
import DashboardGreen from "../../images/dashboard-green.svg";
import DashboardGrey from "../../images/dashboard-grey.svg";
import InvoiceGreen from "../../images/invoice-green.svg";
import InvoiceGrey from "../../images/invoice-grey.svg";
import ItemGreen from "../../images/item-green.svg";
import ItemGrey from "../../images/item-grey.svg";
import LedgerGreen from "../../images/ledger-green.svg";
import LedgerGrey from "../../images/ledger-grey.svg";
import LocationGreen from "../../images/location-green.svg";
import LocationGrey from "../../images/location-grey.svg";
import PurchaseGreen from "../../images/purchase-green.svg";
import PurchaseGrey from "../../images/purchase-grey.svg";
import QuotationGreen from "../../images/quotation-green.svg";
import QuotationGrey from "../../images/quotation-grey.svg";
import ReportGreen from "../../images/report-green.svg";
import ReportGrey from "../../images/report-grey.svg";
import SalaryGreen from "../../images/salary-green.svg";
import SalaryGrey from "../../images/salary-grey.svg";
import SaleReturnGreen from "../../images/saleReturnBill-green.svg";
import SaleReturnGrey from "../../images/saleReturnBill-grey.svg";
import SummaryGreen from "../../images/summary-green.svg";
import SummaryGrey from "../../images/summary-grey.svg";
import VendorGreen from "../../images/vendor-green.svg";
import VendorGrey from "../../images/vendor-grey.svg";
import WareHouseGreen from "../../images/warehouse-green.svg";
import WareHouseGrey from "../../images/warehouse-grey.svg";
import WareHouseBillGreen from "../../images/warehouseBill-green.svg";
import WareHouseBillGrey from "../../images/warehouseBill-grey.svg";
import SalesGreen from "../../images/sale-green.svg";
import SalesGrey from "../../images/sale-grey.svg";

counterpart.registerTranslations("eng", eng);
counterpart.registerTranslations("urdu", urdu);

counterpart.setLocale("eng");

const drawerWidth = 240;

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  // margin: "4px",
  margin: "16px 0",
  fontWeight: "bold",
  [theme.breakpoints.down("md")]: {
    fontSize: "13px",
  },
}));

function AdminSidebar(props) {
  const url = "https://ats-bucket-hardware.s3.amazonaws.com/photos";
  console.log('urllll', url)
  const { lang } = props;
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  let today = moment().format("DD-MM-YY");
  const { expiryDate, status, loading } = useSelector((state) => state.trial);
  const companyCode = localStorage.getItem("companyCode");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [Num, setNum] = useState(0);
  const [selected, setSelected] = useState(false);
  const [modal, setModal] = useState(false);
  const location = localStorage.getItem("data")
  console.log('data', location)
  const dynamicPath = `/inventory/admin/inventory${
    location === "SAR" ? "/Pak" : `/${location}`
  }`;
  const getTab = useGetTab(selected);

  useEffect(() => {
    if (status == "Trial" ) {
      if (expiryDate && findExpireDays(expiryDate) > 0) {
      } else {
        dispatch(getTrial());
      }
    }
  }, [pathname]);

  const openToggle = () => {
    setModal((prev) => !prev);
  };

  const toggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleTab = (e) => {
    setSelected(e);
    if (mobileOpen) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    // dispatch(endTrial());
    dispatch(trailRemoved());
    dispatch(clearInventory());
    history.push("/inventory/login");
    window.location.reload();
  };

  counterpart.setLocale(lang);

  const daysDifference = useMemo(() => {
    if (expiryDate) {
      if (findExpireDays(expiryDate) > 1) {
        return `You have ${findExpireDays(expiryDate)} days left`;
      } else if (findExpireDays(expiryDate) == 1) {
        return "You have 1 day left";
      } else {
        return "You have 0 days left";
      }
    } else {
      return "Free Trial : 0 days left";
    }
  }, [today, expiryDate]);

  const drawer = (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Stack width="100%" justifyContent="center">
          <Link to="/inventory/admin">
            <img
              style={{ paddingLeft: "20px", marginTop: "10px" }}
              className="logoicon"
              src={Logo}
              alt="logo"
            />
          </Link>
          {expiryDate && (
            <Box sx={{ display: "flex", justifyContent: "center", pb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  background: "yellow",
                  p: "4px 6px",
                  borderRadius: "2px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    textAlign: "center",
                    color: "#4eaf51",
                  }}
                >
                  {daysDifference}
                </Typography>
              </Box>
              <Box
                sx={{
                  background: "#4eaf51",
                  p: "4px",
                  width: "25px ",
                  height: "25px ",
                  display: "flex",
                  alignItems: "center",
                  ml: 1,
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={openToggle}
              >
                <Typography
                  sx={{ color: "#fff", fontSize: "14px", textAlign: "center" }}
                >
                  Pay
                </Typography>
              </Box>
            </Box>
          )}
        </Stack>

        <Divider />
        <List>
          <Link to="/inventory/admin/dashboard">
            <div
              className={getTab == "dashboard" ? "navActive" : ""}
              onClick={() => handleTab("dashboard")}
            >
              <ListItem>
                <img
                  className="logoiconsm"
                  src={
                    getTab === "dashboard"
                      ? DashboardGreen
                      : 
                      DashboardGrey
                  }
                  alt="logo"
                ></img>
                <Title>Dashboard</Title>
              </ListItem>
            </div>
          </Link>

          {(companyCode == 4416 || companyCode == 9478) && (
            <Link to="/inventory/admin/property">
              <div
                className={getTab == "property" ? "navActive" : ""}
                onClick={() => handleTab("property")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={getTab === "property" ? PropertyGreen : PropertyGrey}
                    alt="logo"
                  />
                  <Title>Property Form</Title>
                </ListItem>
              </div>
            </Link>
          )}

          {companyCode != 4416 && (
            <Link to="/inventory/admin/outgoing">
              <div
                className={getTab === "outgoing" ? "navActive" : ""}
                onClick={() => handleTab("outgoing")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab === "outgoing"
                        ? SalesGreen
                        : SalesGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Sale</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {companyCode != 4416 && (
            <Link className="center" to="/inventory/admin/inventory">
              <div
                className={getTab === "inventory" ? "navActive" : ""}
                onClick={() => handleTab("inventory")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "inventory"
                        ? ItemGreen
                        : ItemGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Items</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {(companyCode != 4416 && companyCode != 1101) && (
            <Link to="/inventory/admin/summary">
              <div
                className={getTab == "summary" ? "navActive" : ""}
                onClick={() => handleTab("summary")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "summary"
                        ? SummaryGreen
                        : SummaryGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Summary</Title>
                </ListItem>
              </div>
            </Link>
          )}

          <Link to="/inventory/admin/report">
            <div
              className={getTab == "report" ? "navActive" : ""}
              onClick={() => handleTab("report")}
            >
              <ListItem>
                <img
                  className="logoiconsm"
                  src={
                    getTab == "report"
                      ? ReportGreen
                      : ReportGrey
                  }
                  alt="logo"
                ></img>
                <Title>Reports</Title>
              </ListItem>
            </div>
          </Link>

          {companyCode != 4416 && (
            <Link to="/inventory/admin/bills">
              <div
                className={getTab == "bills" ? "navActive" : ""}
                onClick={() => handleTab("bills")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "bills"
                        ? BillGreen
                        : BillGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Bills</Title>
                </ListItem>
              </div>
            </Link>
          )}

          {(companyCode != 4416 &&  companyCode != 6915) && (
            <Link to="/inventory/admin/return-bills">
              <div
                className={getTab == "return-bills" ? "navActive" : ""}
                onClick={() => handleTab("return-bills")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "return-bills"
                        ? SaleReturnGreen
                        : SaleReturnGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Sale Return Bills</Title>
                </ListItem>
              </div>
            </Link>
          )}

{(companyCode == 6915) && (
            <Link to="/inventory/admin/return-bills">
              <div
                className={getTab == "return-bills" ? "navActive" : ""}
                onClick={() => handleTab("return-bills")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "return-bills"
                        ? `${url}/billsGreen.svg`
                        : `${url}/bills.svg`
                    }
                    alt="logo"
                  ></img>
                  <Title>Return Orders</Title>
                </ListItem>
              </div>
            </Link>
          )}

          {companyCode != 4416 && (
            <Link to="/inventory/admin/bank-accounts">
              <div
                className={getTab == "bank-accounts" ? "navActive" : ""}
                onClick={() => handleTab("bank-accounts")}
              >
                <ListItem>
                  <AccountBalanceIcon
                    sx={{
                      mr: 2,
                      ml: 0.8,
                      fontSize: "40px",
                      color: getTab == "bank-accounts" ? "#4eaf52" : "grey",
                    }}
                  />

                  <Title>Bank Accounts</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {companyCode != 4416 && (
            <Link to="/inventory/admin/cash-in-hand">
              <div
                className={getTab == "cash-in-hand" ? "navActive" : ""}
                onClick={() => handleTab("cash-in-hand")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={getTab == "cash-in-hand" ? CashGreen : CashGrey}
                    alt="logo"
                  ></img>

                  <Title>Cash in hand</Title>
                </ListItem>
              </div>
            </Link>
          )}

          <Link to="/inventory/admin/company-profile">
            <div
              className={getTab == "company-profile" ? "navActive" : ""}
              onClick={() => handleTab("company-profile")}
            >
              <ListItem>
                <img
                  className="logoiconsm"
                  src={
                    getTab == "company-profile"
                      ? CompanyProfileGreen
                      : CompanyProfileGrey
                  }
                  alt="logo"
                ></img>
                <Title>Company Profile</Title>
              </ListItem>
            </div>
          </Link>
          {companyCode != 4416 && (
            <Link to="/inventory/admin/sale-returns">
              <div
                className={getTab == "sale-returns" ? "navActive" : ""}
                onClick={() => handleTab("sale-returns")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "sale-returns"
                        ? SaleReturnGreen
                        : SaleReturnGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Sale Return</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {companyCode != 4416 && (
            <Link to="/inventory/admin/purchase-order">
              <div
                className={
                  getTab == "purchase" ||
                  getTab == "final" ||
                  getTab == "returnedorders"
                    ? "navActive"
                    : ""
                }
                onClick={() => handleTab("purchase")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "purchase" ||
                      getTab == "final" ||
                      getTab == "returnedorders"
                        ? PurchaseGreen
                        : PurchaseGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Purchase</Title>
                </ListItem>
              </div>
            </Link>
          )}

          {(getTab == "purchase" ||
            getTab == "final" ||
            getTab == "returnedorders") && (
            <Link
              to={{
                pathname: "/inventory/admin/purchase-order/finalized",
              }}
            >
              <div
                style={{ paddingLeft: "20px" }}
                className={getTab == "final" ? "navActive" : ""}
                onClick={() => handleTab("final")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "final"
                        ? PurchaseGreen
                        : PurchaseGrey
                    }
                    alt="logo"
                  ></img>
                  <Title sx={{ fontSize: "12px", margin: "0" }}>
                    Finalized Orders
                  </Title>
                </ListItem>
              </div>
            </Link>
          )}
          {(getTab == "purchase" ||
            getTab == "final" ||
            getTab == "returnedorders") && (
            <Link
              to={{
                pathname:
                  "/inventory/admin/purchase-order/returned=purcahaseorders",
              }}
            >
              <div
                style={{ paddingLeft: "20px" }}
                className={getTab == "returnedorders" ? "navActive" : ""}
                onClick={() => handleTab("returnedorders")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "returnedorders"
                      ? PurchaseGreen
                      : PurchaseGrey
                    }
                    alt="logo"
                  ></img>
                  <Title sx={{ fontSize: "12px", margin: "0" }}>
                    Returned Orders
                  </Title>
                </ListItem>
              </div>
            </Link>
          )}

          <Link to="/inventory/admin/ledgers">
            <div
              className={getTab == "ledgers" ? "navActive" : ""}
              onClick={() => handleTab("ledgers")}
            >
              <ListItem>
                <img
                  className="logoiconsm"
                  src={
                    getTab == "ledgers"
                      ? LedgerGreen
                      : LedgerGrey
                  }
                  alt="logo"
                ></img>
                <Title>Ledgers</Title>
              </ListItem>
            </div>
          </Link>
          {(companyCode != 4416 && companyCode != 1101)  && (
            <Link to="/inventory/admin/vendors">
              <div
                className={getTab == "vendors" ? "navActive" : ""}
                onClick={() => handleTab("vendors")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "vendors"
                        ? VendorGreen
                        : VendorGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Items Brands</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {companyCode != 4416 && (
            <Link to="/inventory/admin/payment">
              <div
                className={getTab == "payment" ? "navActive" : ""}
                onClick={() => handleTab("payment")}
              >
                <ListItem>
                  {getTab == "payment" ? (
                    <img className="logoiconsm" src={PaymentGreen} alt="logo" />
                  ) : (
                    <img className="logoiconsm" src={PaymentGrey} alt="logo" />
                  )}

                  <Title>Payment</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {(companyCode != 4416 && companyCode != 1101) && (
            <Link to="/inventory/admin/quotations">
              <div
                className={getTab == "quotations" ? "navActive" : ""}
                onClick={() => handleTab("quotations")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "quotations"
                        ? QuotationGreen
                        : QuotationGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Quotation</Title>
                </ListItem>
              </div>
            </Link>
          )}

          <Link to="/inventory/admin/daily-book">
            <div
              className={getTab == "daily-book" ? "navActive" : ""}
              onClick={() => handleTab("daily-book")}
            >
              <ListItem>
                <img
                  className="logoiconsm"
                  src={
                    getTab == "daily-book"
                      ? DailyBookGreen
                      : DailyBookGrey
                  }
                  alt="logo"
                ></img>
                <Title>Daily Book</Title>
              </ListItem>
            </div>
          </Link>
          {(companyCode != 4416 && companyCode != 1101 )&& (
            <Link to="/inventory/admin/expired-items">
              <div
                className={getTab == "expired-items" ? "navActive" : ""}
                onClick={() => handleTab("expired-items")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab === "expired-items" ? expiredItemsG : expiredItems
                    }
                    alt="logo"
                  />
                  <Title>Expired Items</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {(companyCode != 4416 && companyCode != 1101) && (
            <Link to="/inventory/admin/barcode-prints">
              <div
                className={getTab == "barcode-prints" ? "navActive" : ""}
                onClick={() => handleTab("barcode-prints")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab === "barcode-prints"
                        ? BarcodeGreen
                        : BarcodeGrey
                    }
                    alt="logo"
                  />
                  <Title>Barcodes Prints</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {companyCode !== "1101" && (
          <Link to="/inventory/admin/invoices">
            <div
              className={getTab == "invoices" ? "navActive" : ""}
              onClick={() => handleTab("invoices")}
            >
              <ListItem>
                <img
                  className="logoiconsm"
                  src={
                    getTab == "invoices"
                      ? InvoiceGreen
                      : InvoiceGrey
                  }
                  alt="logo"
                />
                {companyCode == 7149 ? (
                  <Title>Estimate</Title>
                ) : (
                  
                    <Title>Invoice</Title>
                   
                )}
              </ListItem>
            </div>
          </Link>
          )}
          {/* {companyCode != 4416 && (
            <Link to="/inventory/admin/fast-cash">
              <div
                className={getTab == "fast-cash" ? "navActive" : ""}
                onClick={() => handleTab("fast-cash")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab === "fast-cash"
                        ? `${url}/fastCashGreen.svg`
                        : `${url}/fastCash.svg`
                    }
                    alt="logo"
                  />
                  <Title>Fast Cash</Title>
                </ListItem>
              </div>
            </Link>
          )} */}

          {(companyCode != 4416 && companyCode != 1101 )&& (
            <Link to="/inventory/admin/employee-salary">
              <div
                className={getTab == "employee-salary" ? "navActive" : ""}
                onClick={() => handleTab("employee-salary")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "employee-salary"
                        ? SalaryGreen
                        : SalaryGrey
                    }
                    alt="logo"
                  />
                  
                  <Title>Employee Salary</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {(companyCode != 4416 && companyCode != 1101) && (
            <Link to="/inventory/admin/warehouse-bills">
              <div
                className={getTab == "warehouse-bills" ? "navActive" : ""}
                onClick={() => handleTab("warehouse-bills")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "warehouse-bills"
                        ? WareHouseBillGreen
                        : WareHouseBillGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Warehouse Bills</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {(companyCode != 4416 && companyCode != 1101) && (
            <Link to="/inventory/admin/location">
              <div
                className={getTab == "location" ? "navActive" : ""}
                onClick={() => handleTab("location")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "location"
                        ? LocationGreen
                        : LocationGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Location</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {(companyCode != 4416 && companyCode != 1101) && (
            <Link to="/inventory/admin/store">
              <div
                className={getTab == "store" ? "navActive" : ""}
                onClick={() => handleTab("store")}
              >
                <ListItem>
                  <StoreIcon
                    sx={{
                      mr: 2,
                      ml: 0.8,
                      fontSize: "40px",
                      color: getTab == "store" ? "#4eaf52" : "grey",
                    }}
                  />

                  <Title>Store</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {/* {companyCode != 4416 && (
            <Link to="/inventory/admin/vouchers">
              <div
                className={getTab == "vouchers" ? "navActive" : ""}
                onClick={() => handleTab("vouchers")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "vouchers"
                        ? `${url}/vouchersGreen.svg`
                        : `${url}/vouchers.svg`
                    }
                    alt="logo"
                  ></img>
                  <Title>Vouchers</Title>
                </ListItem>
              </div>
            </Link>
          )} */}
          {(companyCode != 4416 && companyCode != 1101) && (
            <Link to="/inventory/admin/warehouses">
              <div
                className={getTab == "warehouses" ? "navActive" : ""}
                onClick={() => handleTab("warehouses")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "warehouses"
                        ? WareHouseGreen
                        : WareHouseGrey
                    }
                    alt="logo"
                  ></img>
                  <Title>Warehouse</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {/* {companyCode != 4416 && (
            <Link to="/inventory/admin/vehicles-daily-sheet">
              <div
                className={getTab == "vehicles-daily-sheet" ? "navActive" : ""}
                onClick={() => handleTab("vehicles-daily-sheet")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={getTab == "vehicles-daily-sheet" ? busGreen : busGrey}
                    alt="logo"
                  ></img>
                  <Title>Vehicle Daily Sheet</Title>
                </ListItem>
              </div>
            </Link>
          )}
          {companyCode != 4416 && (
            <Link to="/inventory/admin/vehicles">
              <div
                className={getTab == "vehicles" ? "navActive" : ""}
                onClick={() => handleTab("vehicles")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={getTab == "vehicles" ? busGreen : busGrey}
                    alt="logo"
                  ></img>
                  <Title>Vehicles</Title>
                </ListItem>
              </div>
            </Link>
          )} */}
          {/* {companyCode != 4416 && (
            <Link to="/inventory/admin/employee-route">
              <div
                className={getTab == "employee-route" ? "navActive" : ""}
                onClick={() => handleTab("employee-route")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={getTab == "employee-route" ? busGreen : busGrey}
                    alt="logo"
                  ></img>
                  <Title>Employee Route</Title>
                </ListItem>
              </div>
            </Link>
          )} */}
          {/* {companyCode != 4416 && (
            <Link to="/inventory/admin/user-details">
              <div
                className={getTab == "user-details" ? "navActive" : ""}
                onClick={() => handleTab("user-details")}
              >
                <ListItem>
                  <img
                    className="logoiconsm"
                    src={
                      getTab == "user-details"
                        ? `${url}/user detail green.svg`
                        : `${url}/user detail.svg`
                    }
                    alt="logo"
                  ></img>
                  <Title>User Details</Title>
                </ListItem>
              </div>
            </Link>
          )} */}
        </List>
        {companyCode != 4416 && (
          <>
            <Divider />
            <List>
              <Link to="/inventory/admin/notifications">
                <div
                  style={{ maxHeight: "60px" }}
                  className={getTab == "notifications" ? "navActive" : ""}
                  onClick={() => handleTab("notifications")}
                >
                  <ListItem>
                    <Badge
                      overlap="rectangular"
                      badgeContent={Num}
                      color="secondary"
                      anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    >
                      <img
                        className="logoiconsm"
                        src={
                          getTab == "notifications"
                            ? notificationsgreen
                            : notificationBell
                        }
                        alt="logo"
                      ></img>
                    </Badge>
                    <Title>Notifications</Title>
                  </ListItem>
                </div>
              </Link>
            </List>
          </>
        )}
      </Box>
      <Box sx={{ background: "white" }}>
        <Divider />

        <Stack width="100%" alignItems="center" justifyContent="center">
          <Title
            sx={{
              margin: "0",
              textAlign: "center",
              fontSize: "12px",
              fontWeight: "normal",
            }}
          >
            Logged In as:
          </Title>
          <Title
            sx={{
              margin: "0",
              textAlign: "center",
              fontSize: "12px",
              fontWeight: "normal",
            }}
          >
            {localStorage.getItem("token")}
          </Title>
          <Box sx={{ my: 0.5 }}>
            <Button
              size="small"
              variant="contained"
              sx={{ boxShadow: "none", textTransform: "none" }}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          background: "#FFFFFF",
          boxShadow: "none",
          px: { xs: "1px", md: "60px" },
          display: { xs: "flex", sm: "none", md: "none" },
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: "flex", sm: "flex", md: "none" } }}
            onClick={toggle}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: { xs: "center", sm: "start" },
            }}
          >
            <img src={Logo} alt="logo" />
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { xs: "50%", sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={toggle}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: { xs: "50%", sm: drawerWidth },
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="nav"
        sx={{
          display: { xs: "none", sm: "block" },
          width: drawerWidth,
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="permanent"
          open={mobileOpen}
          onClose={toggle}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>

      {modal && (
        <Dialog open={true} onClose={openToggle} fullWidth maxWidth="xs">
          <DialogContent>
            <Stack spacing={3} alignItems="center" justifyContent="center">
              <Typography sx={{ mt: 1, textAlign: "center" }}>
                Kindly contact the sales department for the payment:
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing="10px">
                <Typography sx={{ color: "#4eaf51" }}>WhatsApp :</Typography>
                <Typography sx={{ color: "#4eaf51" }}>03315921209</Typography>
              </Stack>
              <Button
                variant="contained"
                sx={{ background: "rgb(138, 138, 138) !important" }}
                onClick={openToggle}
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
}

export default AdminSidebar;
